import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    youWillBeBuying: "You'll be Buying",
    manageRecurringBuys: 'Manage Recurring Buys',
    recurringCreated: 'Recurring Buy Created',
    firstBuyOf: 'First Buy of',
    nextBuy: 'Next Buy',
    nextBuyOf: 'Next Buy of',
    creatingRecurringBuy: 'Creating Recurring Buy',
    recurringBuyCreated: 'Recurring Buy Created',
  },
  de: {
    youWillBeBuying: 'Du wirst kaufen',
    manageRecurringBuys: 'Wiederkehrende Käufe verwalten',
    recurringCreated: 'Wiederkehrender Kauf erstellt',
    firstBuyOf: 'Erster Kauf von',
    nextBuy: 'Nächster Kauf',
    nextBuyOf: 'Nächster Kauf von',
    creatingRecurringBuy: 'Wiederkehrenden Kauf erstellen',
    recurringBuyCreated: 'Wiederkehrender Kauf erstellt',
  },
});
